<template>
  <section>
    <b-form inline>
      <b-form-input class="i-100" v-model="searchText" :placeholder="$t('SEARCH')"></b-form-input>
    </b-form>
    
    <div class="clearfix documentTitle">
      <div class="information w-light d-none d-lg-table-cell">
        {{ $t('DOCUMENT.NAME') }}
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        {{ $t('DCLIDENTITY') }}
      </div>
      <div class="information w-light d-none d-lg-table-cell">
        {{ $t('TEAM.TITLE') }}
      </div>
      <div class="extrainformation w-light d-none d-lg-table-cell">
        {{ $t('DOCUMENT.PUBLISHED') }}
      </div>
    </div>
    
    <b-card no-body class="mt-2">
      <template-item v-for="item in items" :item="item" :small="0" :key="item.document.id"></template-item>
    </b-card>


    <b-card v-if="items.length === 0" no-body class="mt-2">
      <b-card-body class="m-4">{{ $t('TEMPLATES.NO_TEMPLATES')}}</b-card-body>
    </b-card>

    <b-pagination
      v-model="currentPage"
      :total-rows="totalItems"
      :per-page="limit"
      align="center"
      @input="getPublished"
    >
      <template v-slot:first-text>{{$t("PAGINATION.FIRST")}}</template>
      <template v-slot:prev-text>{{$t("PAGINATION.PREV")}}</template>
      <template v-slot:next-text>{{$t("PAGINATION.NEXT")}}</template>
      <template v-slot:last-text>{{$t("PAGINATION.LAST")}}</template>
    </b-pagination>
  </section>
</template>
<script>
import TemplateItem from "@/components/Templates/TemplateItem";
export default {
  components: {
    TemplateItem
  },
  data() {
    return {
      currentPage: 1,
      limit: 7,
      items: [],
      searchText: "",
      totalItems: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getPublished: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/templates/team/list", {
          page: this.currentPage,
          limit: this.limit,
          searchText: this.searchText
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  watch: {
    searchText: function() {
      if (this.searchText.length == 0) {
        this.getPublished();
      }
      if (this.searchText.length >= 3) {
        this.getPublished();
      }
    }
  },
  mounted: function() {
    this.getPublished();
  }
};
</script>
<style>
</style>
